import React, { useState, useContext, useEffect } from 'react';
import { UserContext } from '../contexts/userContext';
import { useHistory } from 'react-router';
import LoadingIcon from '../items/buttons/LoadingIcon';
import request from '../../services/Request';
import Swal from 'sweetalert2';
import ModernTable, { ModernPageContainer, ModernPageHeader } from '../dashboard/components/ModernTable';
import { useTheme } from '@mui/material/styles';
import { Autocomplete } from '@mui/material';
import { TextField } from '@mui/material';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import { CloudDownload, CloudDownloadOutlined } from '@mui/icons-material';
import { sortPOS } from '../../services/method/methods';
import UnitSold from '../dashboard/report/Cards/UnitSold';
import TotalRev from '../dashboard/report/Cards/TotalRev';
import Preket from './prekit/Preket';
import { jsPDF } from 'jspdf';
import html2canvas from 'html2canvas';
import { ExportToCsv } from 'export-to-csv';
import html2pdf from 'html2pdf.js';

import {
  FormControlLabel,
  RadioGroup,
  Grid,
  Radio,
  Checkbox,
  Button,
  TableRow,
  TableCell,
  TableContainer,
  TableBody,
  Paper,
  Table,
  TableHead,
  Typography,
  Box,
  Chip,
  alpha,
  Stack,
} from '@mui/material';

import { userLimits } from '../dashboard/uitls/userLimits';
import ViewCashModal from './ViewCashModal';
import ViewCoinModal from './ViewCoinModal';
import InventoryIcon from '@mui/icons-material/Inventory';
import ComputerIcon from '@mui/icons-material/Computer';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import TrendingDownIcon from '@mui/icons-material/TrendingDown';

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

const getGroupsURL = `/groupsAndMachinesForReport/`;
const getMachineURL = `/machines/getMachineProductforInventory`;
const updateMinStock = `/machines/updateMinStock`;
const getProdURL = `/products/`;
const getInventoryByUPC = `/machines/getMachineByProductID/`;

export default function ViewMyMachines(props) {
  const theme = useTheme();
  const { setFiltered, filterd, setTestMode, userEmail } = useContext(UserContext);
  let history = useHistory();

  const [machines, setMachines] = useState([]);
  const [groups, setGroups] = useState([]);
  const [loading, setLoading] = useState(true);
  const [prods, setProds] = useState([]);
  const [groupV, setgroupV] = useState([]);
  const [radio, setRadio] = useState('a');
  const [select, setSelect] = useState({ name: '' });
  const [selectP, setSelectP] = useState({});
  const [sub, setSub] = useState(false);
  const [checked, setChecked] = useState(false);
  const [machineName, setMachineName] = useState('All Machines');
  const [showSelect, setShowSelect] = useState(false);
  const [min, setMin] = useState(0);
  const [row, setRow] = useState([]);
  const [totalStock, setTotalStock] = useState(0);
  const [unitPrice, setUnitPrice] = useState(0);
  const [products, setProducts] = useState([]);
  const [refresh, setRefresh] = useState(false);
  const [diffPlano, setDiffPlano] = useState([]);

  const [tableUPC, settableUPC] = useState([]);

  const [showCash, setshowCash] = useState(false);
  const [showCoin, setshowCoin] = useState(false);

  const [pagination, setPagination] = useState(
    localStorage.getItem('table_view_inven') ? localStorage.getItem('table_view_inven') : 20
  );

  useEffect(() => {
    localStorage.setItem('table_view_inven', pagination);
  }, [pagination]);

  const { tableTitle, _id, superAdmin, access } = userLimits(
    props.match.params.id,
    props.match.params.group,
    'Machines',
    'edit_machine'
  );

  useEffect(() => {
    let isCancelled = false;

    async function getGroups() {
      await request({
        method: 'get',
        url:
          props.match.params.group && superAdmin
            ? getGroupsURL + props.match.params.id
            : getGroupsURL + userEmail,
      }).then((res) => {
        if (!isCancelled) {
          console.log(res.data.machines);
          setGroups(res.data.groups);
          setMachines(res.data.machines);
          setFiltered(res.data.machines);
          setLoading(true);
        }
      });
    }

    async function getProducts() {
      await request({
        method: 'get',
        url:
          props.match.params.group && superAdmin
            ? getProdURL + props.match.params.id + '/report'
            : getProdURL + _id + '/report',
      }).then((res) => {
        if (!isCancelled) {
          setProducts(res.data);
          console.log('allproduct', res.data);
        }
      });
    }

    getGroups();
    getProducts();

    return () => {
      isCancelled = true;
    };
  }, [refresh]);

  const handleChange = async (machines) => {
    setChecked(true);
    if (radio === 'a') {
      setSub(false);
      filterProd(machines);
      setFiltered(machines);
      setMachineName('All Machines');
    }
    if (radio === 'g') {
      setSub(false);
      const myArray = groupV.map((e) => e.machineID);
      var merged = [].concat.apply([], myArray);
      merged = merged.filter((e, i, self) => i === self.findIndex((t) => t._id == e._id));
      const filteredArray = [];
      machines.forEach((e) => {
        merged.findIndex((t) => {
          if (t._id === e._id) {
            filteredArray.push(e);
          }
        });
      });
      setMachineName(`Groups: ${groupV.map((e) => e.name).join(', ')} `);
      filterProd(filteredArray);
      setFiltered(filteredArray);
    }
    if (radio === 'm') {
      setSub(false);
      filterProd(groupV);
      setFiltered(groupV);

      setMachineName(`Machines: ${groupV.map((e) => e.name).join(', ')} `);
    }
    if (radio === 'im') {
      setMachineName(select?.name);
      setSub(true);
      setFiltered(groupV);
      setLoading(false);
      await request({
        method: 'post',
        url: getMachineURL,
        data: {
          machineID: select._id,
        },
      }).then((res) => {
        console.log('individual machine products', res.data);
        let myP = [...res.data[0]];
        const lockerProduct = [...res.data[1]];
        const fridge1 = res.data[2];
        const shelf1 = res.data[3];

        let products = [];

        if (myP.length > 0 && myP[0].idx) {
          myP.forEach((item) => {
            item.pos = item.floor + 'F ' + item.lane + 'L ' + item.idx + 'S';
          });
          products.push(...myP);
        } else {
          myP = sortPOS(myP);
          console.log(myP);
          products.push(...myP);
        }

        if (lockerProduct.length > 0) {
          lockerProduct.forEach((item) => {
            item.pos = item.position + ' Locker';
            item.current_stock = item.isSold ? 0 : 1;
            item.max_stock = 1;
            item.id = item.product;
            products.push(item);
          });
        }

        if (fridge1.length > 0) {
          fridge1.forEach((item) => {
            item.pos = 'Fridge';
            item.max_stock = item.current_stock;
            products.push(item);
          });
        }

        if (shelf1.length > 0) {
          shelf1.forEach((item) => {
            item.pos = 'Shelf';
            item.max_stock = item.current_stock;
            products.push(item);
          });
        }

        setProds(products);
        setLoading(true);
      });
    }
    if ((radio === 'p' || radio === 'ip') && selectP?.upc) {
      setUnitPrice(selectP?.costPrice);
      setMachineName(`Product: ${selectP?.upc} (${selectP?.name?.en})`);
      await request({
        method: 'get',
        url: getInventoryByUPC + selectP?._id,
      }).then((res) => {
        const newArray = [];
        console.log('return product machine', res.data);
        const diffArray = [];
        let total = 0;
        res.data.forEach((machine) => {
          if (machine.diff) {
            diffArray.push(machine.name);
          }
          machine.product.forEach((prod) => {
            if (selectP._id === prod.id) {
              total += prod.current_stock;
              newArray.push({
                name: machine.name,
                description: machine.description,
                current_stock: prod.current_stock,
                max_stock: prod.max_stock,
                pos: prod.pos,
              });
            }
          });
        });
        setTotalStock(total);
        setDiffPlano(diffArray);
        if (radio === 'p') {
          settableUPC(newArray);
          setLoading(true);
        }
        if (radio === 'ip') {
          const array2 = [];
          newArray.forEach((prod) => {
            if (array2.length === 0) {
              array2.push({
                name: prod.name,
                description: prod.description,
                current_stock: prod.current_stock,
                max_stock: prod.max_stock,
              });
            } else {
              const index = array2.findIndex((x) => x.name === prod.name);
              if (index === -1) {
                const addP = {
                  name: prod.name,
                  description: prod.description,
                  current_stock: prod.current_stock,
                  max_stock: prod.max_stock,
                };
                array2.push(addP);
              } else {
                array2[index].current_stock += prod.current_stock;
                array2[index].max_stock += prod.max_stock;
              }
            }
          });

          settableUPC(array2);
          setLoading(true);
        }
      });
    }
  };

  const filterProd = (filterd) => {
    if (radio !== 'im' && radio !== 'p' && radio !== 'ip') {
      let finalProd = [];
      const diffArray = [];

      filterd.forEach((e) => {
        if (e.diff) {
          diffArray.push(e.name);
        }

        e?.product.forEach((prod) => {
          const index = e?.products_min?.findIndex((e) => e?.id === prod?.id?._id);

          if (index > -1) {
            prod.min_stock = e.products_min[index].min;
          }

          if (prod.id) {
            const index = finalProd.findIndex((x) => x._id === prod.id._id);
            if (index === -1) {
              const addP = {
                _id: prod.id._id,
                upc: prod.id.upc,
                name: prod.id.name?.en,
                pos: prod.pos,
                current_stock: prod.current_stock,
                max_stock: prod.max_stock,
                min_stock: prod.min_stock,
                costPrice: prod.id?.costPrice,
                mc: [
                  {
                    name: e.name,
                    description: e.description,
                    current_stock: prod.current_stock,
                    max_stock: prod.max_stock,
                  },
                ],
                indi: [
                  {
                    name: e.name,
                    description: e.description,
                    current_stock: prod.current_stock,
                    max_stock: prod.max_stock,
                    pos: prod?.pos,
                  },
                ],
              };

              finalProd.push(addP);
            } else {
              const findMachine = finalProd[index].mc.findIndex((x) => {
                return x.name === e.name;
              });
              finalProd[index].indi.push({
                name: e.name,
                description: e.description,
                current_stock: prod.current_stock,
                max_stock: prod.max_stock,
                pos: prod?.pos,
              });
              if (findMachine > -1) {
                finalProd[index].mc[findMachine].current_stock += prod.current_stock;
                finalProd[index].mc[findMachine].max_stock += prod.max_stock;
              } else {
                finalProd[index].mc.push({
                  name: e.name,
                  description: e.description,
                  current_stock: prod.current_stock,
                  max_stock: prod.max_stock,
                });
              }

              finalProd[index].current_stock += prod.current_stock;
              finalProd[index].max_stock += prod.max_stock;
            }
          }
        });
      });
      setDiffPlano(diffArray);
      console.log('finalProd', finalProd);
      setProds(finalProd);
    }
  };

  const toggleEditMinStock = () => {
    if (filterd.length > 1 && !showSelect) {
      Swal.fire({
        title: 'Are you sure?',
        text: 'The action will applied to all of your selected machines.',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes',
      }).then((result) => {
        if (result.isConfirmed) {
          setShowSelect(!showSelect);
        }
      });
    } else {
      setShowSelect(!showSelect);
    }
  };

  useEffect(() => {
    setShowSelect(false);
    setChecked(false);
  }, [radio]);

  const submitMin = async () => {
    const filterdID = filterd.map((e) => e._id);
    const newData = [];
    const newProds = [...prods];
    newProds.forEach((e) => {
      if (e.min_stock || e.min_stock === 0) {
        let myData = {};
        myData.id = e._id;
        myData.min = e.min_stock;
        myData.sent = false;
        newData.push(myData);
      }
    });

    await request({
      method: 'post',
      url: updateMinStock,
      data: {
        machineID: filterdID,
        products_min: newData,
      },
    }).then((res) => {
      Swal.fire({
        text: `The min stock has been successfully updated`,
        icon: 'success',
        target: document.getElementById('swal2-container'),
      }).then((e) => {
        setRefresh(!refresh);
      });
    });
  };

  const updateMin = async () => {
    const newProds = [...prods];
    newProds.forEach((element) => {
      const index = row.findIndex((idx) => idx._id === element._id);
      if (index > -1) {
        element.min_stock = min;
      }
    });

    setProds(newProds);
  };

  const columns = sub
    ? [
        {
          title: 'Product Name',
          editable: 'never',
          render: (rowData) => (
            <Typography variant="body1" sx={{ fontWeight: 600 }}>
              {rowData.id?.name?.en}
            </Typography>
          ),
        },
        {
          title: 'UPC/SKU',
          editable: 'never',
          field: 'id.upc',
          render: (rowData) => (
            <Typography variant="body2" sx={{ fontFamily: 'monospace' }}>
              {rowData.id?.upc}
            </Typography>
          ),
        },
        {
          title: 'Unit Cost',
          field: 'id.costPrice',
          render: (rowData) =>
            rowData.id?.costPrice ? (
              <Chip
                icon={<AttachMoneyIcon sx={{ fontSize: 16 }} />}
                label={`$${rowData.id.costPrice.toFixed(2)}`}
                size="small"
                sx={{
                  fontWeight: 600,
                  backgroundColor: alpha(theme.palette.warning.main, 0.12),
                  color: theme.palette.warning.dark,
                  border: `1.5px solid ${alpha(theme.palette.warning.main, 0.3)}`,
                  '& .MuiChip-icon': { color: theme.palette.warning.dark },
                }}
              />
            ) : null,
        },
        { title: 'Current Stock', field: 'current_stock' },
        { title: 'Max Stock', field: 'max_stock' },
        {
          title: 'Shortage',
          render: (rowData) => {
            const shortage = rowData?.max_stock - rowData?.current_stock;
            return shortage > 0 ? (
              <Chip
                icon={<TrendingDownIcon sx={{ fontSize: 16 }} />}
                label={shortage}
                size="small"
                sx={{
                  fontWeight: 600,
                  backgroundColor: alpha(theme.palette.error.main, 0.12),
                  color: theme.palette.error.dark,
                  border: `1.5px solid ${alpha(theme.palette.error.main, 0.3)}`,
                  '& .MuiChip-icon': { color: theme.palette.error.dark },
                }}
              />
            ) : (
              <Typography variant="body2">0</Typography>
            );
          },
        },
        { title: 'Position', field: 'pos' },
      ]
    : [
        {
          title: 'Product Name',
          editable: 'never',
          field: 'name',
          render: (rowData) => (
            <Typography variant="body1" sx={{ fontWeight: 600 }}>
              {rowData.name}
            </Typography>
          ),
        },
        {
          title: 'UPC',
          editable: 'never',
          field: 'upc',
          render: (rowData) => (
            <Typography variant="body2" sx={{ fontFamily: 'monospace' }}>
              {rowData.upc}
            </Typography>
          ),
        },
        {
          title: 'Unit Cost',
          field: 'costPrice',
          render: (rowData) =>
            rowData.costPrice ? (
              <Chip
                icon={<AttachMoneyIcon sx={{ fontSize: 16 }} />}
                label={`$${rowData.costPrice.toFixed(2)}`}
                size="small"
                sx={{
                  fontWeight: 600,
                  backgroundColor: alpha(theme.palette.warning.main, 0.12),
                  color: theme.palette.warning.dark,
                  border: `1.5px solid ${alpha(theme.palette.warning.main, 0.3)}`,
                  '& .MuiChip-icon': { color: theme.palette.warning.dark },
                }}
              />
            ) : null,
        },
        { title: 'Current Stock', field: 'current_stock' },
        { title: 'Max Stock', field: 'max_stock' },
        {
          title: 'Shortage',
          render: (rowData) => {
            const shortage = rowData?.max_stock - rowData?.current_stock;
            return shortage > 0 ? (
              <Chip
                icon={<TrendingDownIcon sx={{ fontSize: 16 }} />}
                label={shortage}
                size="small"
                sx={{
                  fontWeight: 600,
                  backgroundColor: alpha(theme.palette.error.main, 0.12),
                  color: theme.palette.error.dark,
                  border: `1.5px solid ${alpha(theme.palette.error.main, 0.3)}`,
                  '& .MuiChip-icon': { color: theme.palette.error.dark },
                }}
              />
            ) : (
              <Typography variant="body2">0</Typography>
            );
          },
        },
        {
          title: (
            <Box sx={{ whiteSpace: 'normal', wordWrap: 'break-word' }}>
              Min Stock
              <Typography variant="caption" display="block" sx={{ fontWeight: 400, opacity: 0.7 }}>
                (showing the value of the first machine if you selected multiple machines)
              </Typography>
            </Box>
          ),
          field: 'min_stock',
        },
      ];

  const prod_column =
    radio === 'p'
      ? [
          {
            title: 'Machine ID',
            field: 'name',
            render: (rowData) => (
              <Chip
                icon={<ComputerIcon sx={{ fontSize: 16 }} />}
                label={rowData.name}
                size="small"
                sx={{
                  fontWeight: 600,
                  backgroundColor: alpha(theme.palette.info.main, 0.12),
                  color: theme.palette.info.dark,
                  border: `1.5px solid ${alpha(theme.palette.info.main, 0.3)}`,
                  '& .MuiChip-icon': { color: theme.palette.info.dark },
                }}
              />
            ),
          },
          { title: 'Machine Desc', field: 'description' },
          { title: 'Current Stock', field: 'current_stock' },
          { title: 'Max Stock', field: 'max_stock' },
          { title: 'Position', field: 'pos' },
        ]
      : [
          {
            title: 'Machine ID',
            field: 'name',
            render: (rowData) => (
              <Chip
                icon={<ComputerIcon sx={{ fontSize: 16 }} />}
                label={rowData.name}
                size="small"
                sx={{
                  fontWeight: 600,
                  backgroundColor: alpha(theme.palette.info.main, 0.12),
                  color: theme.palette.info.dark,
                  border: `1.5px solid ${alpha(theme.palette.info.main, 0.3)}`,
                  '& .MuiChip-icon': { color: theme.palette.info.dark },
                }}
              />
            ),
          },
          { title: 'Machine Desc', field: 'description' },
          { title: 'Current Stock', field: 'current_stock' },
          { title: 'Max Stock', field: 'max_stock' },
        ];

  return (
    <ModernPageContainer>
      {!loading && <LoadingIcon />}

      <ModernPageHeader
        title="Inventory Management"
        subtitle="Monitor stock levels, manage inventory, and track product availability across machines"
        icon={InventoryIcon}
      />

      <ViewCashModal show={showCash} onHide={() => setshowCash(false)} data={select} />
      <ViewCoinModal show={showCoin} onHide={() => setshowCoin(false)} data={select} />

      {/* Filter Section */}
      <Paper
        elevation={0}
        sx={{
          p: 4,
          mb: 3,
          borderRadius: 3,
          background: `linear-gradient(135deg, ${alpha(theme.palette.background.paper, 0.9)} 0%, ${alpha(
            theme.palette.background.paper,
            0.95
          )} 100%)`,
          border: `1px solid ${theme.palette.divider}`,
          boxShadow: `0 4px 20px ${alpha(theme.palette.primary.main, 0.08)}`,
        }}
      >
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            mb: 3,
            flexWrap: 'wrap',
            gap: 2,
          }}
        >
          <Typography
            variant="h6"
            sx={{
              fontWeight: 700,
              color: theme.palette.primary.main,
            }}
          >
            Filter Options
          </Typography>
          <Typography
            variant="caption"
            sx={{
              color: theme.palette.info.main,
              fontWeight: 500,
              display: 'flex',
              alignItems: 'center',
              gap: 0.5,
            }}
          >
            ℹ️ Positions are only available for individual machine view
          </Typography>
        </Box>

        <Grid container spacing={3} alignItems="flex-start">
          {/* Radio Group Section - Now Full Width */}
          <Grid item xs={12}>
            <Box
              sx={{
                p: 2.5,
                borderRadius: 2,
                backgroundColor: alpha(theme.palette.primary.main, 0.04),
                border: `1px solid ${alpha(theme.palette.primary.main, 0.1)}`,
              }}
            >
              <Typography
                variant="subtitle2"
                sx={{
                  mb: 2,
                  fontWeight: 600,
                  color: theme.palette.text.primary,
                }}
              >
                View Type
              </Typography>
              <RadioGroup
                row
                name="bg_radio"
                onChange={(e) => {
                  setRadio(e.target.value);
                  setgroupV([]);
                }}
                sx={{
                  display: 'flex',
                  flexWrap: 'wrap',
                  gap: 2,
                }}
              >
                <FormControlLabel
                  value="a"
                  control={<Radio size="small" />}
                  label={
                    <Typography variant="body2" sx={{ fontWeight: 500 }}>
                      All Machines
                    </Typography>
                  }
                  checked={radio === 'a'}
                />
                <FormControlLabel
                  value="g"
                  control={<Radio size="small" />}
                  label={
                    <Typography variant="body2" sx={{ fontWeight: 500 }}>
                      Groups
                    </Typography>
                  }
                  checked={radio === 'g'}
                />
                <FormControlLabel
                  value="m"
                  control={<Radio size="small" />}
                  label={
                    <Typography variant="body2" sx={{ fontWeight: 500 }}>
                      Machines
                    </Typography>
                  }
                  checked={radio === 'm'}
                />
                <FormControlLabel
                  value="im"
                  control={<Radio size="small" />}
                  label={
                    <Typography variant="body2" sx={{ fontWeight: 500 }}>
                      Individual Machine
                    </Typography>
                  }
                  checked={radio === 'im'}
                />
                <FormControlLabel
                  value="ip"
                  control={<Radio size="small" />}
                  label={
                    <Typography variant="body2" sx={{ fontWeight: 500 }}>
                      Product (Combined)
                    </Typography>
                  }
                  checked={radio === 'ip'}
                />
                <FormControlLabel
                  value="p"
                  control={<Radio size="small" />}
                  label={
                    <Typography variant="body2" sx={{ fontWeight: 500 }}>
                      Product (Individual)
                    </Typography>
                  }
                  checked={radio === 'p'}
                />
              </RadioGroup>
            </Box>
          </Grid>

          {/* Selection Section */}
          <Grid item xs={12} md={9}>
            <Stack spacing={2}>
              {radio === 'a' && (
                <TextField variant="outlined" label="All Machines" fullWidth disabled />
              )}

              {radio === 'g' && (
                <Autocomplete
                  multiple
                  value={groupV}
                  options={groups}
                  disableCloseOnSelect
                  onChange={(event, value) => {
                    setgroupV(value);
                    setChecked(false);
                  }}
                  isOptionEqualToValue={(option, value) => option._id === value._id}
                  getOptionLabel={(option) => option.name}
                  renderOption={(props, option, { selected }) => (
                    <li {...props}>
                      <Checkbox
                        icon={icon}
                        checkedIcon={checkedIcon}
                        style={{ marginRight: 8 }}
                        checked={selected}
                      />
                      {option.name}
                    </li>
                  )}
                  fullWidth
                  renderInput={(params) => <TextField {...params} variant="outlined" label="Groups" />}
                />
              )}

              {radio === 'm' && (
                <Autocomplete
                  multiple
                  value={groupV}
                  options={machines}
                  disableCloseOnSelect
                  onChange={(event, value) => {
                    setgroupV(value);
                    setChecked(false);
                  }}
                  isOptionEqualToValue={(option, value) => option._id === value._id}
                  getOptionLabel={(option) => option.name}
                  renderOption={(props, option, { selected }) => (
                    <li {...props}>
                      <Checkbox
                        icon={icon}
                        checkedIcon={checkedIcon}
                        style={{ marginRight: 8 }}
                        checked={selected}
                      />
                      {option.description ? `${option.name}(${option.description})` : option.name}
                    </li>
                  )}
                  fullWidth
                  renderInput={(params) => (
                    <TextField {...params} variant="outlined" label="Machines" />
                  )}
                />
              )}

              {radio === 'im' && (
                <Autocomplete
                  value={select}
                  fullWidth
                  id="addToMachine"
                  options={machines}
                  onChange={(event, value) => {
                    setSelect(value);
                  }}
                  getOptionLabel={(option) =>
                    option.description ? `${option.name}(${option.description})` : option.name
                  }
                  renderInput={(params) => (
                    <TextField {...params} label="Select a machine" variant="outlined" />
                  )}
                />
              )}

              {(radio === 'p' || radio === 'ip') && (
                <Autocomplete
                  value={selectP}
                  fullWidth
                  id="addToMachine"
                  options={products}
                  onChange={(event, value) => {
                    setSelectP(value);
                  }}
                  getOptionLabel={(option) => (option?.upc ? `${option.upc} (${option.name?.en})` : '')}
                  renderInput={(params) => (
                    <TextField {...params} label="Select a Product" variant="outlined" />
                  )}
                />
              )}
            </Stack>
          </Grid>

          {/* Action Buttons Section */}
          <Grid item xs={12} md={3}>
            <Stack direction="row" spacing={1.5} flexWrap="wrap">
              <Button
                disabled={
                  groupV.length === 0 && radio !== 'a' && radio !== 'im' && radio !== 'p' && radio !== 'ip'
                }
                onClick={() => {
                  handleChange(machines);
                }}
                variant="contained"
                size="large"
                sx={{
                  flex: '1 1 auto',
                  py: 1.5,
                  fontWeight: 600,
                  boxShadow: `0 4px 12px ${alpha(theme.palette.primary.main, 0.3)}`,
                  '&:hover': {
                    boxShadow: `0 6px 16px ${alpha(theme.palette.primary.main, 0.4)}`,
                    transform: 'translateY(-2px)',
                  },
                  transition: 'all 0.2s ease-in-out',
                }}
              >
                Submit
              </Button>

              {radio !== 'im' && radio !== 'p' && radio !== 'ip' && checked && (
                <Button
                  onClick={toggleEditMinStock}
                  variant={showSelect ? 'outlined' : 'contained'}
                  color="primary"
                  size="large"
                  sx={{
                    flex: '1 1 auto',
                    py: 1.5,
                    fontWeight: 600,
                    textTransform: 'uppercase',
                  }}
                >
                  {showSelect ? 'Turn Off' : 'Edit Min Stock'}
                </Button>
              )}
            </Stack>

            {radio === 'im' && (select?.cashInfo || select?.coinInfo) && (
              <Stack spacing={1.5} sx={{ mt: 1.5 }}>
                {select?.cashInfo && (
                  <Button
                    fullWidth
                    onClick={() => {
                      setshowCash(true);
                    }}
                    variant="outlined"
                    size="medium"
                    sx={{
                      fontWeight: 600,
                      borderWidth: 2,
                      '&:hover': {
                        borderWidth: 2,
                      },
                    }}
                  >
                    View Cash
                  </Button>
                )}
                {select?.coinInfo && (
                  <Button
                    fullWidth
                    onClick={() => {
                      setshowCoin(true);
                    }}
                    variant="outlined"
                    size="medium"
                    sx={{
                      fontWeight: 600,
                      borderWidth: 2,
                      '&:hover': {
                        borderWidth: 2,
                      },
                    }}
                  >
                    View Coin
                  </Button>
                )}
              </Stack>
            )}
          </Grid>
        </Grid>
      </Paper>

      {/* Warning Alert */}
      {diffPlano?.length > 0 && (
        <Paper
          elevation={0}
          sx={{
            mb: 3,
            p: 3,
            borderRadius: 2,
            backgroundColor: alpha(theme.palette.error.main, 0.08),
            border: `2px solid ${alpha(theme.palette.error.main, 0.3)}`,
            borderLeft: `6px solid ${theme.palette.error.main}`,
          }}
        >
          <Stack spacing={1}>
            <Typography variant="subtitle2" color="error.main" sx={{ fontWeight: 700 }}>
              ⚠️ Planogram Mismatch Detected
            </Typography>
            <Typography variant="body2" color="error.dark" sx={{ fontWeight: 500 }}>
              Planogram between machine and dashboard is different on the following machine(s):
              <Box component="span" sx={{ fontWeight: 700 }}>
                {diffPlano.map((e, i) => {
                  if (i === diffPlano.length - 1) {
                    return <span key={i}>{` ${e}`}</span>;
                  } else {
                    return <span key={i}>{` ${e},`}</span>;
                  }
                })}
              </Box>
            </Typography>
            <Typography variant="body2" color="error.dark" sx={{ fontWeight: 500, fontStyle: 'italic' }}>
              This may result in incorrect inventory counts
            </Typography>
          </Stack>
        </Paper>
      )}

      {/* Min Stock Edit Section - Only show when Edit Mode is ON */}
      {showSelect && radio !== 'im' && radio !== 'p' && radio !== 'ip' && checked && (
        <Paper
          elevation={0}
          sx={{
            p: 3,
            mb: 3,
            borderRadius: 3,
            backgroundColor: alpha(theme.palette.warning.main, 0.05),
            border: `1px solid ${alpha(theme.palette.warning.main, 0.2)}`,
          }}
        >
          <Typography variant="h6" sx={{ mb: 2, fontWeight: 700, color: theme.palette.warning.dark }}>
            Manage Minimum Stock Levels
          </Typography>
          <Box
            sx={{
              mb: 2,
              p: 2,
              borderRadius: 2,
              backgroundColor: alpha(theme.palette.info.main, 0.08),
              border: `1px solid ${alpha(theme.palette.info.main, 0.2)}`,
            }}
          >
            <Typography variant="body2" color="info.dark" sx={{ fontWeight: 500 }}>
              💡 Tip: Set min to -1 if you do not want to receive email notifications for this product
            </Typography>
          </Box>
          <Stack direction="row" spacing={2} alignItems="center" flexWrap="wrap">
            <TextField
              value={min}
              variant="outlined"
              size="medium"
              onChange={(e) => {
                setMin(e.target.value);
              }}
              type="number"
              label="Min Stock Value"
              InputProps={{ inputProps: { min: -1 } }}
              sx={{
                minWidth: 180,
                '& .MuiOutlinedInput-root': {
                  fontWeight: 600,
                },
              }}
            />
            <Button
              onClick={updateMin}
              variant="contained"
              color="primary"
              disabled={!checked}
              sx={{
                fontWeight: 600,
                boxShadow: `0 4px 12px ${alpha(theme.palette.primary.main, 0.3)}`,
              }}
            >
              Apply to Selected
            </Button>
            <Button
              onClick={submitMin}
              variant="contained"
              color="primary"
              disabled={!checked}
              sx={{
                fontWeight: 600,
                boxShadow: `0 4px 12px ${alpha(theme.palette.primary.main, 0.3)}`,
              }}
            >
              Save Changes
            </Button>
          </Stack>
        </Paper>
      )}

      <Box sx={{ mb: 12 }}>

        {radio === 'p' || radio === 'ip' ? (
          <div>
            <Grid container spacing={3} justifyContent="center" sx={{ mb: 3 }}>
              <Grid item xs={12} sm={6} md={3}>
                <UnitSold title="Total Stock" unit={totalStock} />
              </Grid>
              <Grid item xs={12} sm={6} md={3}>
                <TotalRev title="Cost Price" rev={unitPrice?.toFixed(2)} />
              </Grid>
            </Grid>
            <ModernTable
              columns={prod_column}
              data={tableUPC}
              title={`${machineName}`}
              options={{
                actionsColumnIndex: -1,
                pageSize: 20,
                pageSizeOptions: [10, 20, 50, 100, 200],
                selection: showSelect,
                idSynonym: 'name',
              }}
              onSelectionChange={(rows) => {
                setRow(rows);
              }}
              actions={[
                {
                  tooltip: 'Download csv',
                  isFreeAction: true,
                  icon: CloudDownload,
                  onClick: (evt, data) => {
                    const outPutArray = tableUPC.map((prod) => {
                      if (radio === 'ip') {
                        return {
                          machine_ID: prod.name,
                          description: prod.description,
                          current_stock: prod.current_stock,
                          max_stock: prod.max_stock,
                        };
                      }
                      return {
                        machine_ID: prod.name,
                        description: prod.description,
                        current_stock: prod.current_stock,
                        max_stock: prod.max_stock,
                        Position: prod.pos,
                      };
                    });

                    const options = {
                      fieldSeparator: ',',
                      quoteStrings: '"',
                      decimalSeparator: '.',
                      useTextFile: false,
                      filename: 'Inventory_report',
                      useKeysAsHeaders: true,
                    };

                    const csvExporter = new ExportToCsv(options);
                    csvExporter.generateCsv(outPutArray);
                  },
                },
              ]}
            />
          </div>
        ) : (
          <ModernTable
            onRowsPerPageChange={setPagination}
            columns={columns}
            data={prods}
            title={`${machineName}`}
            options={{
              actionsColumnIndex: -1,
              pageSize: parseInt(pagination),
              pageSizeOptions: [10, 20, 50, 100, 200],
              selection: showSelect,
              idSynonym: '_id',
            }}
            detailPanel={({ rowData }) => {
              if (radio === 'im') return <div></div>;
              else
                return (
                  <TableContainer
                    component={Paper}
                    style={{
                      backgroundColor:
                        theme.palette.mode === 'dark' ? theme.palette.grey[900] : '#EBEBE8',
                      paddingLeft: '46px',
                    }}
                  >
                    <Table>
                      <TableHead>
                        <TableRow>
                          <TableCell>Machine Name</TableCell>
                          <TableCell>Machine Desc</TableCell>
                          <TableCell>Current_Stock</TableCell>
                          <TableCell>Max_Stock</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {rowData.mc.map((m, index) => {
                          return (
                            <TableRow key={m.name}>
                              <TableCell align="left">{m.name}</TableCell>
                              <TableCell align="left">{m.description}</TableCell>
                              <TableCell align="left">{m.current_stock}</TableCell>
                              <TableCell align="left">{m.max_stock}</TableCell>
                            </TableRow>
                          );
                        })}
                      </TableBody>
                    </Table>
                  </TableContainer>
                );
            }}
            onSelectionChange={(rows) => {
              setRow(rows);
            }}
            actions={[
              radio === 'im' && {
                tooltip: 'Download csv',
                isFreeAction: true,
                icon: CloudDownload,
                onClick: (evt, data) => {
                  const outPutArray = prods.map((e) => {
                    if (sub) {
                      return {
                        Product_Name: e.id?.name?.en,
                        UPC: e.id?.upc,
                        Unit_Cost: e.id?.costPrice ? e.id?.costPrice : '',
                        Current_Stock: e.current_stock,
                        Max_Stock: e.max_stock,
                        Position: e.pos,
                      };
                    }
                    return {
                      Product_Name: e.name,
                      UPC: e.upc,
                      Unit_Cost: e.costPrice,
                      Current_Stock: e.current_stock,
                      Max_Stock: e.max_stock,
                      Min_Stock: e.min_stock,
                    };
                  });
                  const options = {
                    fieldSeparator: ',',
                    quoteStrings: '"',
                    decimalSeparator: '.',
                    useTextFile: false,
                    filename: 'Inventory_report',
                    useKeysAsHeaders: true,
                  };

                  const csvExporter = new ExportToCsv(options);
                  csvExporter.generateCsv(outPutArray);
                },
              },

              prods.length > 0 &&
                prods[0].idx && {
                  tooltip: 'Download Prekit Report',
                  isFreeAction: true,
                  icon: CloudDownloadOutlined,
                  onClick: (evt, data) => {
                    const input = document.getElementById('pkToPrint');
                    if (input) {
                      var opt = {
                        margin: [15, 15],
                        filename: 'Prekit_Report.pdf',
                        image: { type: 'jpeg', quality: 0.98 },
                        html2canvas: { scale: 2, letterRendering: true, useCORS: true },
                        jsPDF: { unit: 'pt', format: 'letter', orientation: 'portrait' },
                        pagebreak: { mode: ['avoid-all', 'css', 'legacy'] },
                      };

                      html2pdf().from(input).set(opt).save();
                    }
                  },
                },
              !sub && {
                tooltip: 'Download All Products csv',
                isFreeAction: true,
                icon: CloudDownloadOutlined,
                onClick: (evt, data) => {
                  if (!sub) {
                    let obj = [];
                    prods.forEach((e) => {
                      e?.mc.forEach((mc) => {
                        obj.push({
                          Product_Name: e.name,
                          UPC: e.upc,
                          Machine_Name: mc.name,
                          Machine_Description: mc.description,
                          Unit_Cost: e.costPrice ? e.costPrice : '',
                          Current_Stock: mc.current_stock,
                          Max_Stock: mc.max_stock,
                        });
                      });
                    });
                    const options = {
                      fieldSeparator: ',',
                      quoteStrings: '"',
                      decimalSeparator: '.',
                      useTextFile: false,
                      filename: 'Inventory_report',
                      useKeysAsHeaders: true,
                    };

                    const csvExporter = new ExportToCsv(options);
                    csvExporter.generateCsv(obj);
                  }
                },
              },
            ]}
          />
        )}
      </Box>
      {prods?.length > 0 && prods[0].idx && <Preket data={prods} referTo={_id} select={select} />}
    </ModernPageContainer>
  );
}
